import React, {Fragment} from 'react';
import loader from '../../Assets/img/loader.svg'
const FullScreenLoader = (props) => {
    return (
        <Fragment>
            <div className={props.isLoading+" LoadingOverlay text-center center-screen"}>
                <img alt="loader" className="progressCustom-logo" src={loader}/>
            </div>
        </Fragment>
    );
};

export default FullScreenLoader;